var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.70828 6.66672H1.45828C0.654144 6.66672 0 6.01257 0 5.20828V1.45828C0 0.654144 0.654144 0 1.45828 0H7.70828C8.51257 0 9.16672 0.654144 9.16672 1.45828V5.20828C9.16672 6.01257 8.51257 6.66672 7.70828 6.66672ZM1.45828 1.25C1.34338 1.25 1.25 1.34338 1.25 1.45828V5.20828C1.25 5.32333 1.34338 5.41672 1.45828 5.41672H7.70828C7.82333 5.41672 7.91672 5.32333 7.91672 5.20828V1.45828C7.91672 1.34338 7.82333 1.25 7.70828 1.25H1.45828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70828 20H1.45828C0.654144 20 0 19.3458 0 18.5417V9.79169C0 8.9874 0.654144 8.33325 1.45828 8.33325H7.70828C8.51257 8.33325 9.16672 8.9874 9.16672 9.79169V18.5417C9.16672 19.3458 8.51257 20 7.70828 20ZM1.45828 9.58325C1.34338 9.58325 1.25 9.67664 1.25 9.79169V18.5417C1.25 18.6566 1.34338 18.75 1.45828 18.75H7.70828C7.82333 18.75 7.91672 18.6566 7.91672 18.5417V9.79169C7.91672 9.67664 7.82333 9.58325 7.70828 9.58325H1.45828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5419 20H12.2919C11.4876 20 10.8335 19.3458 10.8335 18.5417V14.7917C10.8335 13.9874 11.4876 13.3333 12.2919 13.3333H18.5419C19.3461 13.3333 20.0002 13.9874 20.0002 14.7917V18.5417C20.0002 19.3458 19.3461 20 18.5419 20ZM12.2919 14.5833C12.1769 14.5833 12.0835 14.6766 12.0835 14.7917V18.5417C12.0835 18.6566 12.1769 18.75 12.2919 18.75H18.5419C18.6568 18.75 18.7502 18.6566 18.7502 18.5417V14.7917C18.7502 14.6766 18.6568 14.5833 18.5419 14.5833H12.2919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5419 11.6667H12.2919C11.4876 11.6667 10.8335 11.0126 10.8335 10.2083V1.45828C10.8335 0.654144 11.4876 0 12.2919 0H18.5419C19.3461 0 20.0002 0.654144 20.0002 1.45828V10.2083C20.0002 11.0126 19.3461 11.6667 18.5419 11.6667ZM12.2919 1.25C12.1769 1.25 12.0835 1.34338 12.0835 1.45828V10.2083C12.0835 10.3233 12.1769 10.4167 12.2919 10.4167H18.5419C18.6568 10.4167 18.7502 10.3233 18.7502 10.2083V1.45828C18.7502 1.34338 18.6568 1.25 18.5419 1.25H12.2919Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.446e29c7c3f750a73b05a7dbcd8d6b05.svg";
export { ForwardRef as ReactComponent };